import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';

const tabHeaders = [
  'Compte',
  'Donnée\u{202F}\u{202F}Compte',
  'Données\u{202F}\u{202F}Revolving',
  'Statut\u{202F}\u{202F}Compte\u{202F}\u{202F}Revol.',
  'Limite\u{202F}\u{202F}Crédit\u{202F}\u{202F}E...',
  'Gestion\u{202F}\u{202F}Risque', // \u{202F} = code js caractère insécable
  'Paramètres\u{202F}\u{202F}Base',
  'Paramètres\u{202F}\u{202F}Recharge\u{202F}\u{202F}Automatique',
  'Frais\u{202F}\u{202F}Assurance',
  'Frais\u{202F}\u{202F}Périodiques\u{202F}\u{202F}Divers',
];

const tabLinks = [
  'about',
  'account-data',
  'revolving-data',
  'revolving-account-status',
  'credit-limit',
  'risk-management',
  'prepaid-basic-parameters',
  'prepaid-reload-parameters',
  'insurance-fees',
  'miscellaneous-periodic-fees',
];

const AccountDetailLayout = () => {

    const {pathname} = useLocation();
    const arr = pathname.split('/');
    const index = tabLinks.findIndex((value, index) => value === arr[arr.length - 1]);
    
    // const orientation = CC.useBreakpointValue(
    //     { 
    //         base: 'horizontal', 
    //         "2xl": 'vertical', 
    //     }, 
    //     { 
    //         fallback: 'md', 
    //     }, 
    // ) as "horizontal" | "vertical";
            
    const bg = CC.useColorModeValue('gray.400', 'whiteAlpha.700');

    return (
        <>
      
            {/* Back to previous page Section */}
            <CC.HStack>
                <Link
                to={
                    URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.ACCOUNT
                }
                >
                <CC.Box
                    borderRadius={'50%'}
                    p={'0.5rem'}
                    _hover={{ backgroundColor: `${bg}` }}
                >
                    <FaArrowLeft size={'1.5rem'} />
                </CC.Box>
                </Link>

                <CC.Hide below="md">
                <CC.Heading size="lg">Consultation Des Comptes</CC.Heading>
                </CC.Hide>

                <CC.Show below="md">
                <CC.Heading size="lg">Retour</CC.Heading>
                </CC.Show>
            </CC.HStack>

            <CC.Divider my={'2rem'} />

            <CC.Heading size="md" ml={8}>Donnée Compte</CC.Heading>

            <CC.Tabs isLazy defaultIndex={index} px={{ base: "1rem", xl: '2rem'}} mt={"2rem"} columnGap={8}>
                <CC.Box as={"div"} style={{ overflow: 'auto' }} minW={'15%'} mt={'1.2rem'}>
                <CC.TabList  alignItems={"flex-start"}>
                    {tabHeaders.map((tab, index) => (
                    <NavLink to={tabLinks[index]} key={index}>
                        <CC.Tab _hover={{ textColor: `${CC.useColorModeValue('black.50', 'red.50')}`, backgroundColor: `${CC.useColorModeValue('blue.50', 'blue.600')}`, borderRadius: "5px" }}>
                        {tab}
                        </CC.Tab>
                    </NavLink>
                    ))}
                </CC.TabList>
                </CC.Box>

                <CC.TabPanels>
                {tabHeaders.map((_, index) => (
                    <CC.TabPanel key={index}>
                    <Outlet />
                    </CC.TabPanel>
                ))}
                </CC.TabPanels>
            </CC.Tabs>
        </>
    );
};

export default AccountDetailLayout;
